module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("To my readers,")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Thank you for your infinite support before, during, and after the release of the first book in the Colour Coded series.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Because of that, the publishing of this book was possible. Because of that, you have made my dreams come true.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("That alone, is a debt I can only repay by continuing to invite you to join me in the adventures of Colour Coded and by remaining hopeful that I continue to serve you well.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0